import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 896;

// export function useIsMobile() {
//   const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

//   useEffect(() => {
//     const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
//     const onChange = () => {
//       setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
//     };
//     mql.addEventListener("change", onChange);
//     setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
//     return () => mql.removeEventListener("change", onChange);
//   }, []);

//   return !!isMobile;
// }


/**
 * 判断当前运行环境是否为移动设备
 * @returns {boolean} 返回 true 表示是移动设备，false 表示非移动设备
 */
export function isMobileDevice(): boolean {
  // 处理非浏览器环境（如 Node.js）的边界情况
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }

  // 匹配移动设备的正则表达式，覆盖主流移动设备类型
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i;
  
  // 检测 userAgent 中是否包含移动设备特征
  const userAgent = window.navigator.userAgent;
  return mobileRegex.test(userAgent);
}

// 扩展：更精准的移动端判断（区分手机/平板）
/**
 * 判断当前是否为手机设备（排除平板）
 * @returns {boolean}
 */
// export function isMobilePhone(): boolean {
//   if (typeof window === 'undefined' || !window.navigator) {
//     return false;
//   }

//   const userAgent = window.navigator.userAgent;
//   // 匹配手机特征，同时排除平板
//   const phoneRegex = /Android.*Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
//   const tabletRegex = /iPad|Android(?!.*Mobile)|Tablet/i;

//   return phoneRegex.test(userAgent) && !tabletRegex.test(userAgent);
// }